<template>
    <ProductHeader />
    <LazySudosuFrame />
    <LazyCountryLaunchingBanner />
    <LazyUnsubscribeInvitationBanner />
    <LazyHeaderUnlogged v-if="$ff('new-unlogged-navbar')" />
    <LazyNavbarUnlogged v-else />
    <main class="relative">
        <slot />
    </main>
    <LazyFooterUnlogged :always-visible="true" />
    <LazyProductFooter />
</template>

<script setup lang="ts">
    import {LazyFooterUnlogged, LazyHeaderUnlogged, LazyNavbarUnlogged, LazySudosuFrame} from '#components';
    import {useHead} from '#imports';
    import LazyCountryLaunchingBanner from '~/components/CountryLaunchingBanner.vue';
    import LazyProductFooter from '~/components/product/ProductFooter.vue';
    import ProductHeader from '~/components/product/ProductHeader.vue';
    import LazyUnsubscribeInvitationBanner from '~/components/UnsubscribeInvitationBanner.vue';

    useHead({
        bodyAttrs: {class: `page-product`},
    });
</script>

<style lang="scss">
    @use '~/assets/styles/product';
</style>
